import { AxiosPromise } from 'axios'
import { createUserClient } from './createUserClient'
import { getUser, update, createTeam, deleteAvatar, getTeams, deleteUser, createNonce, passwordReset, startChunk, chunk, endChunk, upload } from './methods'
import { UserClient as BaseUserClient, UserClientOptions, GetUserResponseData } from './types'

export default function UserClient(options?: UserClientOptions): UserClient {
  const commonOptions = {}

  return createUserClient({
    ...commonOptions,
    ...options,
    methods: {
      getUser,
      createTeam,
      deleteAvatar,
      update,
      deleteUser,
      getTeams,
      createNonce,
      passwordReset,
      startChunk,
      chunk,
      endChunk,
      upload
    },
  })
}

export type UserClient = BaseUserClient & {
  readonly getUser: () => AxiosPromise<GetUserResponseData>;
  readonly createTeam: (data: any) => AxiosPromise;
  readonly update: (user: any) => AxiosPromise;
  readonly deleteUser: () => AxiosPromise;
  readonly getTeams: () => AxiosPromise;
  readonly deleteAvatar: () => AxiosPromise;
  readonly createNonce: (key_armored: any) => AxiosPromise;
  readonly upload: (attachment: any, onUploadProgress?: (progressEvent: any) => void) => AxiosPromise;
  readonly startChunk: (attachment: any, onUploadProgress?: (progressEvent: any) => void) => AxiosPromise;
  readonly chunk: (handle: string, attachment: any, number: number, onUploadProgress?: (progressEvent: any) => void) => AxiosPromise;
  readonly endChunk: (handle: string, attachment: any, number: number, onUploadProgress?: (progressEvent: any) => void) => AxiosPromise;
  readonly passwordReset: (password: string, private_key_armored: string, public_key_armored: string) => AxiosPromise;
}
